
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  computed,
  watch,
  onUnmounted,
  onBeforeMount,
  onBeforeUnmount,
  nextTick,
} from "vue";
import { Switch, Dialog, Toast } from "vant";
import { swiper } from "@/utils/swiper";
import { querySpaceConditioners, setSpaceCondtioners } from "@/apis/envmonitor";
import { parseImgUrl, setQueryConfig } from "@/utils";
import any = jasmine.any;

export default defineComponent({
  props: {
    temperature: {
      // 空调基本信息
      type: Number,
      default: () => 0,
    },
    hasAir: {
      // 有无空调
      type: Boolean,
      default: () => false,
    },
    airVolumes: {
      // 风量信息
      type: Array,
      default: () => [],
    },
    projectId: {
      type: String,
      default: () => "",
    },
    spaceId: {
      type: String,
      default: () => "",
    },
    userIsControl: {
      type: Boolean,
      default: () => false,
    },
    forceOverTimeFlag: {
      type: Boolean,
      default: () => false,
    },
    seviceEquipmentList: {
      // 是否走服务定制的设备
      type: Array,
      default: () => [],
    },
  },
  components: {
    Switch,
    [Dialog.Component.name]: Dialog.Component,
  },
  setup(props, contx) {
    const propsVal = props;
    let airData: any = {
      avg: "", // 算法调节温度（目标值）
      icon: 1, // 固定框文案ID 7 为关机，其它都是开机
      spaceStatus: "", // 固定框文案展示
      notice: "", // 弹框文案展示
      mode: 0, //  模式
      tempSet: 0, // 温度
      maxTempSet: 32,
      minTempSet: 16,
      isAutoGear: 0,
      workMode: 0, //1=cold(制冷)；2=hot(制热)；3=wind(通风)
      gear: 0, //  风量
      isOpen: false, // 空调开关 true 是开
      runStatus: 0, // 查询设备的真实状态
    };
    const feedbackTimer: any = null;
    const airTimer: any = null;
    const domAirOpeen: any = false;
    let realTemp: any = 16;
    let windGearArr: any = [0, 1, 2, 3];
    let equipList: any = [];
    let valueDom: any = null;
    let valueHeight: any = null;
    let spaceId: any = "";
    const proxyData = reactive({
      seviceEquipmentList: props.seviceEquipmentList,
      valueDom: valueDom,
      spaceId: spaceId,
      valueHeight: valueHeight,
      equipList: equipList,
      cotrolLoading: false,
      loadingTimer: 0,
      airTemp: 0, // 设备真实温度
      loadingAir: false,
      windGearArr: windGearArr, // 风量3/5个档位
      lightIcon: "arrow-down",
      showChild: false,
      realTemp: realTemp,
      temperature: props.temperature,
      userIsControl: props.userIsControl,
      forceOverTimeFlag: props.forceOverTimeFlag,
      firstLoadingAir: true,
      domAirOpeen: domAirOpeen,
      swiperIinit: false,
      parseImgUrl: parseImgUrl,
      part: 1,
      airData: airData,
      modeName: "",
      showAirVolumeBtn: false, // 是否展示风量调节按钮
      showDialog: false,
      airTimer: airTimer,
      airSetText: {
        // 空调反馈文案
        notice: "",
        remark: [],
        nowImg: "",
        toWhere: "",
        designTemperature: 0,
      },
      // 点击展示所有的登录
      async showAll() {
        proxyData.showChild = !proxyData.showChild;
        if (proxyData.lightIcon === "arrow-up") {
          proxyData.lightIcon = "arrow-down";
        } else {
          proxyData.lightIcon = "arrow-up";
        }

        if (proxyData.showChild) {
          await nextTick(() => {
            proxyData.setChildSelectList();
          });
        } else {
          await nextTick(() => {
            proxyData.barSwiperInit();
          });
        }

        // proxyData.getAirInfoToTimer(0);
      },
      // 设置温度条的位置
      setBarNowPerstion() {
        proxyData.realTemp = proxyData.airTemp;
        let barBox: any = document.querySelector("#barId");
        // console.log("设置温度位置---");
        // console.log(barBox)
        if (!barBox) {
          return;
        }
        let sliderBox: any = document.querySelector("#sliderId");
        if (
          proxyData.airTemp >= proxyData.airData.minTempSet &&
          proxyData.airTemp <= proxyData.airData.maxTempSet
        ) {
          // 正常温度范围
          let left: any =
            ((proxyData.airTemp - proxyData.airData.minTempSet) / 0.5) *
            proxyData.part;
          left = Math.floor(left);
          if (barBox) {
            barBox.style.left = left + "px";
          }
        } else {
          if (!proxyData.airTemp) {
            barBox.style.left = 0 + "px";
          } else if (proxyData.airTemp < proxyData.airData.minTempSet) {
            barBox.style.left = 0 + "px";
          } else if (proxyData.airTemp > proxyData.airData.maxTempSet) {
            let sliderWidth: any = sliderBox.offsetWidth;
            let barWidth: any = barBox.offsetWidth;
            barBox.style.left = sliderWidth - barWidth + "px";
          }
        }
      },
      // 滑动
      endBoxSwiper() {
        proxyData.swiperIinit = true;
        let handBox: any = document.querySelector("#handId");
        let barBox: any = document.querySelector("#barId");
        let sliderBox: any = document.querySelector("#sliderId");
        let isMove: any = false;
        let barLeft: any = 0;
        let sliderWidth: any = sliderBox ? sliderBox.offsetWidth : 1;
        let barWidth: any = barBox ? barBox.offsetWidth : 20;
        let tempPart =
          (proxyData.airData.maxTempSet - proxyData.airData.minTempSet) / 20;
        let part: any = 0.5 / (tempPart / (Math.floor(sliderWidth) / 22));
        proxyData.part = part;
        if (!handBox) {
          return;
        }
        handBox.addEventListener("touchstart", function (e: any) {
          barLeft = isNaN(parseInt(barBox.style.left))
            ? 0
            : parseInt(barBox.style.left);
          isMove = true;
        });
        handBox.addEventListener("touchend", function (e: any) {
          isMove = false;
          proxyData.changeZongAir("temp", proxyData.realTemp);
          proxyData.airTemp = proxyData.realTemp;
        });
        swiper(handBox, {
          swipeLeft: function (e: any) {
            if (isMove) {
              barLeft = Math.abs(barLeft);
              let moveRealX: any = Math.abs(e.mation.moveX - e.mation.startX);
              let left: any = barLeft - moveRealX;
              left = left < 0 ? 0 : left;
              barBox.style.left = left + "px";
              proxyData.realTemp =
                proxyData.airData.minTempSet + Math.ceil(left / part) * 0.5;
            }
          },
          swipeRight: function (e: any) {
            if (isMove) {
              barLeft = Math.abs(barLeft);
              let moveRealX: any = Math.abs(e.mation.moveX - e.mation.startX);
              let left: any = barLeft + moveRealX;
              left = left > sliderWidth ? sliderWidth - barWidth : left;
              barBox.style.left = left + "px";
              proxyData.realTemp =
                proxyData.airData.minTempSet + Math.ceil(left / part) * 0.5;
              if (proxyData.realTemp > proxyData.airData.maxTempSet) {
                proxyData.realTemp = proxyData.airData.maxTempSet;
              }
            }
          },
        });
      },
      // 定时获取空调状态
      getAirInfoToTimer(timerLong: any = 10000) {
        if (proxyData.airTimer) {
          clearTimeout(proxyData.airTimer);
          proxyData.airTimer = null;
        }
        proxyData.airTimer = setTimeout(function () {
          proxyData.getAirInfo();
        }, timerLong);
      },
      // 计算loading时间
      setLoadingNumber() {
        let timer: any = setInterval(() => {
          proxyData.loadingTimer++;
          console.log(proxyData.loadingTimer);
          if (proxyData.loadingTimer >= 15) {
            clearInterval(timer);
            proxyData.loadingAir = false;
            proxyData.getAirInfoToTimer(0);
          }
        }, 1000);
      },
      // 格式化空调数据
      formatAirData(btnType: any, text: any) {
        let obj: any = {};
        if (btnType == "temp") {
          obj.codeKey = "tempSetCode";
          obj.value = text;
        }
        if (btnType == "gear" && text == "windLow") {
          //降挡
          if (proxyData.airData.gear > 1) {
            proxyData.airData.gear--;
            proxyData.airData.isAutoGear = 0;
            obj.value = proxyData.airData.gear;
            obj.codeKey = "gearCode";
          } else {
            return;
          }
        }
        if (btnType == "gear" && text == "windUp") {
          //升档
          if (proxyData.airData.gear < 3) {
            proxyData.airData.gear++;
            proxyData.airData.isAutoGear = 0;
            obj.value = proxyData.airData.gear;
            obj.codeKey = "gearCode";
          } else {
            return;
          }
        }
        if (btnType == "gear" && text == "auto") {
          proxyData.airData.isAutoGear = proxyData.airData.isAutoGear ? 0 : 1;
          obj.value = proxyData.airData.isAutoGear ? 4 : proxyData.airData.gear;
          obj.codeKey = "gearCode";
        }
        if (btnType == "mode") {
          proxyData.airData.workMode = text;
          obj.codeKey = "modeSetCode";
          obj.value = text;
        }
        return obj;
      },
      /**
       * 加载loading
       */
      loadingStart() {
        proxyData.cotrolLoading = true;
      },
      /**
       * 结束
       */
      loadinngEnd() {
        proxyData.cotrolLoading = false;
      },
      // 计算loading时间
      setChildLoadingNumber(childItem: any) {
        childItem.loadingTimer = 1;
        let timer: any = setInterval(() => {
          childItem.loadingTimer++;
          if (childItem.loadingTimer >= 15) {
            clearInterval(timer);
            childItem.loadingTimer = 0;
            proxyData.getAirInfoToTimer(0);
          }
          console.log("===");
          console.log(childItem.loadingTimer);
        }, 1000);
      },
      // 连续点击2秒内未点击才发指令
      childDisabled(childItem: any, data: any) {
        clearTimeout(childItem.timeOuter);
        childItem.timeOuter = setInterval(() => {
          childItem.num--;
          if (childItem.num == 0) {
            proxyData.setSpaceCondtioners(data);
            clearTimeout(childItem.timeOuter);
          }
        }, 1000);
      },
      // 子设备降低温度
      changeChildItemAir(btnType: any, childItem: any, symbol: any) {
        const domAirOpen = !childItem.isOpen;
        let isExeSpaceTime: Boolean = proxyData.checkDeviceIsExeSpaceTime([
          childItem,
        ]);
        if (proxyData.forceOverTimeFlag && domAirOpen && isExeSpaceTime) {
          //需要强制加班
          contx.emit("triggerWork", 2, childItem);
          return;
        }
        if (!childItem.isOpen && btnType !== "switch") {
          return;
        }
        let arr: any = [];
        if (btnType === "switch") {
          if (childItem.loadingTimer >= 1 && childItem.loadingTimer <= 15) {
            return;
          }
          childItem.isOpen = !childItem.isOpen;
          proxyData.setChildLoadingNumber(childItem);
          let obj: any = {
            id: childItem.id, //类型：String  必有字段  备注：设备id
            code: childItem.switchCode, //类型：String  必有字段  备注：编码 EquipSwtichSet
            value: childItem.isOpen ? "1" : "0", //类型：String  必有字段  备注：值 0
          };
          arr.push(obj);
          // loadig的状态
        } else if (btnType === "temp") {
          childItem.num = 2;
          if (symbol === "up") {
            if (childItem.tempSet >= proxyData.airData.maxTempSet) {
              return;
            }
            childItem.tempSet = childItem.tempSet + 0.5;
          } else if (symbol === "down") {
            if (childItem.tempSet <= proxyData.airData.minTempSet) {
              return;
            }
            childItem.tempSet = childItem.tempSet - 0.5;
          }
          let obj: any = {
            id: childItem.id, //类型：String  必有字段  备注：设备id
            code: childItem.tempSetCode, //类型：String  必有字段  备注：编码 EquipSwtichSet
            value: childItem.tempSet, //类型：String  必有字段  备注：值 0
          };
          arr.push(obj);
          proxyData.childDisabled(childItem, arr);
        } else if (btnType === "gear") {
          if (symbol === "up") {
            if (childItem.isAutoGear) {
              return;
            }
            if (childItem.gear >= 3) {
              childItem.isAutoGear = 1;
            } else {
              childItem.gear++;
              childItem.isAutoGear = 0;
            }
          } else if (symbol === "down") {
            if (!childItem.isAutoGear && childItem.gear <= 1) {
              return;
            }
            if (childItem.isAutoGear) {
              childItem.isAutoGear = 0;
              childItem.gear = 3;
            } else {
              childItem.gear--;
            }
          }
          let obj: any = {
            id: childItem.id, //类型：String  必有字段  备注：设备id
            code: childItem.gearCode, //类型：String  必有字段  备注：编码 EquipSwtichSet
            value: childItem.isAutoGear ? 4 : childItem.gear, //类型：String  必有字段  备注：值 0
          };
          arr.push(obj);
        } else if (btnType === "model") {
          if (symbol === "up") {
            if (childItem.workMode >= 3) {
              return;
            }
            childItem.workMode++;
          } else if (symbol === "down") {
            if (childItem.workMode <= 1) {
              return;
            }
            childItem.workMode--;
          }
          let obj: any = {
            id: childItem.id, //类型：String  必有字段  备注：设备id
            code: childItem.modeSetCode, //类型：String  必有字段  备注：编码 EquipSwtichSet
            value: childItem.workMode, //类型：String  必有字段  备注：值 0
          };
          arr.push(obj);
        }
        // 修改单个设备的状态
        if (btnType !== "temp") {
          proxyData.setSpaceCondtioners(arr);
        }
        proxyData.updateChildPerstion();
      },
      // 改变设备状态
      setSpaceCondtioners(data: any) {
        setSpaceCondtioners(data)
          .then((res) => {
            // proxyData.setLoadingNumber();
            proxyData.loadinngEnd();
          })
          .catch(() => {
            // proxyData.setLoadingNumber();
            proxyData.loadinngEnd();
          });
      },
      // 改变空调状态
      changeZongAir(btnType: any, text: any) {
        if (!airData.runStatus) return;
        let equpObj: any = proxyData.formatAirData(btnType, text);
        let data: any = [];
        proxyData.equipList.map((item: any) => {
          let obj: any = {
            id: item.id, //类型：String  必有字段  备注：设备id
            code: item[equpObj.codeKey], //类型：String  必有字段  备注：编码 EquipSwtichSet
            value: equpObj.value, //类型：String  必有字段  备注：值 0
          };
          data.push(obj);
        });
        console.log("设备数据处理---");
        console.log(data);
        if (!proxyData.cotrolLoading) {
          proxyData.loadingStart();
          // 调整设备状态
          proxyData.setSpaceCondtioners(data);
        }
      },
      // 检查设备是否执行空间服务时间
      checkDeviceIsExeSpaceTime(deviceAll: any = []) {
        let seviceEquipmentList: any = proxyData.seviceEquipmentList;
        let flag: any = false;
        for (let i = 0; i < seviceEquipmentList.length; i++) {
          for (let j = 0; j < deviceAll.length; j++) {
            if (
              seviceEquipmentList[i].id == deviceAll[j].id &&
              seviceEquipmentList[i].isExeSpaceTime
            ) {
              flag = true;
              break;
            }
          }
          if (flag) {
            break;
          }
        }
        return flag;
      },
      // 总控制改变空调状态
      airChange() {
        // 先不更新状态等确认框弹出后再更新状
        // 操作空调
        const domAirOpen = !proxyData.airData.isOpen;
        let isExeSpaceTime: Boolean = proxyData.checkDeviceIsExeSpaceTime(
          proxyData.equipList
        );
        if (proxyData.forceOverTimeFlag && domAirOpen && isExeSpaceTime) {
          //需要强制加班
          contx.emit("triggerWork", 2);
          return;
        }

        proxyData.airData.isOpen = !proxyData.airData.isOpen;
        proxyData.loadingAir = true;
        proxyData.loadingTimer = 0;
        clearTimeout(proxyData.airTimer);
        proxyData.setLoadingNumber();
        let data: any = [];
        proxyData.equipList.map((item: any) => {
          let obj: any = {
            id: item.id, //类型：String  必有字段  备注：设备id
            code: item.switchCode, //类型：String  必有字段  备注：编码 EquipSwtichSet
            value: proxyData.airData.isOpen ? "1" : "0", //类型：String  必有字段  备注：值 0
          };
          data.push(obj);
        });
        // 设备状态处理
        proxyData.setSpaceCondtioners(data);
      },
      // 设置子设备的状态
      formateSetChildStatus() {
        proxyData.equipList.map((item: any) => {
          item.isOpen = item.runStatus === 1 ? true : false;
        });
      },
      // 初始化滚动
      async barSwiperInit() {
        if (proxyData.airData.isOpen && !proxyData.showChild) {
          proxyData.endBoxSwiper();
          proxyData.setBarNowPerstion();
        }
      },
      // 设置子设备的可调范围
      setChildSelectList() {
        proxyData.equipList.map((item: any) => {
          let tempArr: any = [];
          for (
            let i = proxyData.airData.minTempSet;
            i <= proxyData.airData.maxTempSet;
            i = i + 0.5
          ) {
            tempArr.push(i);
          }
          item.tempArr = tempArr;
          let index: any = item.tempArr.findIndex((ele: any) => {
            return ele == item.tempSet;
          });
          item.sel = index == -1 ? 0 : index;

          let modelArr: any = ["制冷", "制热", "通风"];
          item.modelArr = modelArr;
          let mIndex: any = item.workMode ? item.workMode - 1 : 2;
          item.mIndex = mIndex;

          let gearArr: any = [0, 1, 2, 3, "AUTO"];
          item.gearArr = gearArr;
          let gIndex: any = item.gearArr.findIndex((ele: any) => {
            if (item.isAutoGear == 1) {
              return ele == "AUTO";
            } else {
              return ele == item.gear;
            }
          });
          item.gIndex = gIndex == -1 ? 0 : gIndex;
        });
        proxyData.setValueHeight();
      },
      setValueHeight() {
        if (!proxyData.valueHeight) {
          proxyData.valueDom = proxyData.valueDom
            ? proxyData.valueDom
            : document.querySelectorAll(".value")[0];
          proxyData.valueHeight = proxyData.valueDom
            ? proxyData.valueDom.offsetHeight
            : 0;
        }
        console.log("proxyData.valueHeight==", proxyData.valueHeight);
      },
      // 改变子设备选中的位置
      updateChildPerstion() {
        proxyData.equipList.map((item: any) => {
          let index: any = item.tempArr.findIndex((ele: any) => {
            return ele == item.tempSet;
          });
          item.sel = index == -1 ? 0 : index;

          let mIndex: any = item.workMode ? item.workMode - 1 : 2;
          item.mIndex = mIndex;

          let gIndex: any = item.gearArr.findIndex((ele: any) => {
            if (item.isAutoGear == 1) {
              return ele == "AUTO";
            } else {
              return ele == item.gear;
            }
          });
          item.gIndex = gIndex == -1 ? 0 : gIndex;
        });
      },
      // 空调信息airTemp
      getAirInfo() {
        const paramObj = {
          // // projectId: props.projectId, //'Pj1101080255'
          // projectId: "Pj1101080255",
          // spaceId: "Sp110108025564f438d7fef64eea8202a6462f1bbcce",
          spaceId: proxyData.spaceId,
          // spaceId: props.spaceId,//'Sp110108025564f438d7fef64eea8202a6462f1bbcce' 空间id
        };
        //wx.showLoading();
        let str: any = setQueryConfig(paramObj);
        querySpaceConditioners(str)
          .then((res) => {
            let data: any = res.data || {};
            proxyData.firstLoadingAir = false;
            proxyData.loadingAir = false;
            proxyData.airTemp = data.tempSet;
            proxyData.airData.maxTempSet = data.maxTempSet;
            proxyData.airData.minTempSet = data.minTempSet;
            proxyData.airData.isOpen = data.runStatus ? true : false;
            proxyData.airData.runStatus = data.runStatus;
            proxyData.airData.isAutoGear = data.isAutoGear;
            proxyData.airData.gear = data.gear;
            proxyData.airData.workMode = data.workMode;
            proxyData.equipList = data.equipList;
            // 设置子设备的状态
            proxyData.setChildSelectList();
            proxyData.formateSetChildStatus();

            // 设置当前温度的位置
            if (proxyData.airData.isOpen) {
              proxyData.airData.airImg = parseImgUrl(
                "page-officehome",
                "openair.png"
              );
            } else {
              proxyData.airData.airImg = parseImgUrl(
                "page-officehome",
                "air_close.png"
              );
            }

            nextTick(() => {
              proxyData.barSwiperInit();
            });
            proxyData.getAirInfoToTimer();
          })
          .catch(() => {});
      },
    });
    watch(props, (newProps: any) => {
      if (newProps.spaceId) {
        // proxyData.swiperIinit = false;
        proxyData.spaceId = newProps.spaceId;
        // proxyData.getAirInfoToTimer(0);
        proxyData.temperature = props.temperature;
        proxyData.userIsControl = newProps.userIsControl;
        proxyData.forceOverTimeFlag = newProps.forceOverTimeFlag;
        proxyData.seviceEquipmentList = props.seviceEquipmentList;
      }
    });
    onBeforeUnmount(() => {
      if (proxyData.airTimer) {
        clearTimeout(proxyData.airTimer);
        proxyData.airTimer = null;
      }
    });
    onMounted(() => {
      proxyData.spaceId = props.spaceId;
      proxyData.getAirInfoToTimer(0);
      // 获取空调信息
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
